var path = 'areas/projects/actions/wildfly/Octopus.WildFlyState_summary.html';
var html = "<p> Enable or Disable deployments in WildFly/Red Hat JBoss EAP instances in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/wildfly/Octopus.WildFlyState_summary.html
// module id = 4701148827549556
// module chunks = 1